import React, { ReactNode } from "react";

interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: ReactNode;
  fullWidth?: boolean;
  color?: string;
  size?: "sm" | "md" | "lg";
  loading?: boolean;
}

const AppButton: React.FC<AppButtonProps> = ({
  label,
  fullWidth = true,
  color = "#4fd1c5",
  size = "md",
  loading = false,
  disabled,
  ...props
}) => {
  const sizeClasses =
    size === "sm"
      ? "py-2 text-sm"
      : size === "lg"
      ? "py-4 text-lg"
      : "py-3 text-base";

  return (
    <button
      type="submit"
      className={`btn text-white rounded-3 ${sizeClasses} ${
        fullWidth ? "w-100" : ""
      }`}
      style={{ backgroundColor: color }}
      disabled={disabled || loading}
      {...props}
    >
      {label}
    </button>
  );
};

export default AppButton;
